import { render, staticRenderFns } from "./contentLectureVDO.vue?vue&type=template&id=73ccbcf2&"
import script from "./contentLectureVDO.vue?vue&type=script&lang=js&"
export * from "./contentLectureVDO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports